export default "__VITE_ASSET__DlI$DPwC__"